import home_tabs from '../home/home_tabs.js'

export default [
  {
    id: "status",
    type_name: {
      en: "Status",
      zh: "状态"
    },
    ui_cfg_block_item: true,
    ui_cfg_hide_item_defaulte: true,
    items: [
      {
        id: "for_sale",
        name: {
          en: "For Sale",
          zh: "卖出"
        }
      },
      {
        id: "on_auction",
        name: {
          en: "On Auction",
          zh: "拍卖"
        }
      },
      {
        id: "has_offer",
        name: {
          en: "Has Offer",
          zh: "有人出价"
        }
      },
      {
        id: "new",
        name: {
          en: "New",
          zh: "最新商品"
        }
      }
    ]
  },
  {
    id: "categories",
    type_name: {
      en: "Categories",
      zh: "类型"
    },
    ui_cfg_hide_item_defaulte: true,
    items: home_tabs
  }
];